import { type User } from '../../../../contexts/authContext/types/user.type';
import { APPLICATION_STATUS_TYPE } from '../../../../utils/statusConstants/statusConstants';

export const HoDToDoFilter = (user: User | null): any => {
  return {
    status: {
      in: [APPLICATION_STATUS_TYPE.UNDER_HOD_DOS],
    },
  };
};
